
var getters = {
	//试卷库
	getReqParams:(state,getters,rootState)=>{
		var head = state.papers_head;
		return {
			['classify']: head.subjects&& head.subjects[head.subject_i].id || 0,
			['class']: head.types[head.type_i].id,
			['order']: state.papers_list.sort_id,
			page: rootState.common.current_page -1,
			size: rootState.common.page_size
		}
	},
	getStoreParams:(state,getters,rootState)=>{
		try {
			var grade = state.selectedMsg1.map(v=>v.id).join(","),
				grades = state.selectedMsg2.id,
				chapterid = state.tree_info.map(v=>v.id).join(","),
				classtitle = state.selectedMsg1.map(v=>v.title).join(",") + "," + state.selectedMsg2.title + ","
											+ state.tree_info.map(v=>v.title).join(",");
			var str = `grade=${grade}&grades=${grades}&chapterid=${chapterid}&classtitle=${classtitle}`;
			window.localStorage.setItem("newppt",str);
		} catch(err) {
			console.error(err);
			var str = "";
		}
		return str;
	},
	getJiaocaiId:(state,getters,rootState)=>{
		return {
			gradeid: state.selectedMsg2.id,
			gradesid: state.selectedMsg2.id,
			classid: state.selectedMsg1.map(v=>v.id).join(","),
			chapterid: state.tree_info.map(v=>v.id).join(","),
		}
	},
	getAllTitle:(state)=>{
		return state.selectedMsg1.map(v=>v.title).concat([state.selectedMsg2.title,state.tree_info.map(v=>v.title).join("")]).join(",");
	},
	//获取共享资源详情的title
	getComplexTitle:(state)=>{
		var titles = state.shareDetail.info&&state.shareDetail.info.classtitle&&state.shareDetail.info.classtitle.split(",");
		if(titles) {
			return `${titles[0]}${titles[1]}(${titles[2]}) · ${titles[3]} | ${titles[4]}`
		} else {
			return ""
		}
	},
	//获取组合title
	getSelect1:(state)=>{
		return state.selectedMsg1.reduce((prev,next)=>{
		  return prev+next.title;
		},"");
	},
	//获取小学语文苏教版+一年级上册
	getComputedTreeId:(state)=>{
		if(!state.selectedMsg1[2]) {
			return "";
		}
		return state.selectedMsg1[3].id;
	},
	//获取节信息
	getjieid:(state)=>{
		return state.tree_info[state.tree_info.length - 1] && state.tree_info[state.tree_info.length - 1].id;
	},

	//获取年级
	getGrades:(state)=>{
		var grades = [...state.grades],
				selectedMsg2 = state.selectedMsg2;
		return grades.map(v=>{
			if(v.id == selectedMsg2.id) {
				v.active = true;
			} else {
				v.active = false;
			}
			return v;
		});	
	},
	getActiveVersions:(state)=> {
		var versions = Object.assign({},state.versions),
				selectedMsg1 = state.selectedMsg1;
		if(selectedMsg1.length > 0) {
			versions.schools = versions.schools.map(v=>{
				if(v.id == selectedMsg1[0].id) {
					v.active = true;
				} else {
					v.active = false;
				}
				return v;
			})
			versions.subjects = versions.subjects.map(v=>{
				if(v.id == selectedMsg1[1].id) {
					v.active = true;
				} else {
					v.active = false;
				}
				return v;
			})
			versions.publishers = versions.publishers.map(v=>{
				if(v.id == selectedMsg1[2].id) {
					v.active = true;
				} else {
					v.active = false;
				}
				return v;
			})
			versions.grade = versions.grade.map(v=>{
				if(v.id == selectedMsg1[3].id) {
					v.active = true;
				} else {
					v.active = false;
				}
				return v;
			})
		}
		return versions;
	},


	//获取资源列表的资源id,并拼接成数组
	getResourceids:(state)=>{
		var resourceids = state.resources.map(v=>v.id);
		return resourceids;
	}
}
export default getters
	


// WEBPACK FOOTER //
// ./src/store/modules/teaching/getters.js